import { Jour } from './jour';

export class Semaine { 
  
	public Jours: [Jour, Jour, Jour, Jour, Jour, Jour, Jour]

  constructor() {
  	this.Jours = [new Jour(), new Jour(), new Jour(), new Jour(), new Jour(), new Jour(), new Jour()];
  }
}